<template>
  <div>
    <child1
      :model.sync="StockCollect.jsonobj"
      :list.sync="StockCollect.list"
      @shop-up="ShoppingCart"
      @up-date="StockCollectSear"
    />

    <el-pagination
      style="padding:10px 0;"
      background
      :current-page="StockCollect.pageNo"
      :page-sizes="[30, 50, 100, 150, 200, 500]"
      :page-size.sync="StockCollect.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="StockCollect.total"
      @size-change="StockCollectSear()"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import child1 from '../user/children/child1.vue'
import request from './api.js'
import quest from '../api/user'
export default {
  components: { child1 },
  data() {
    return {
      StockCollect: {
        list: [],
        pageNo: 1,
        pageSize: 30,
        total: 0,
        jsonobj: {
          sortType: 0,
          fBuyCount: true
        }
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.StockCollect.pageNo = val
      this.StockCollectSear()
    },
    StockCollectSear(rest, fn) {
      if (rest === true) {
        this.StockCollect.pageNo = 1
        this.StockCollect.pageSize = 30
        this.StockCollect.total = 0
      } else if (rest === 'reset' && this.StockCollect.list.length === 1 && this.StockCollect.pageNo !== 1) {
        this.StockCollect.pageNo = Math.floor(this.StockCollect.total / this.StockCollect.pageSize)
      }
      const jsonobj = JSON.parse(JSON.stringify(this.StockCollect.jsonobj))
      jsonobj.fBuyCount = Number(jsonobj.fBuyCount)
      request
        .queryStockCollect({
          pageNo: this.StockCollect.pageNo,
          pageSize: this.StockCollect.pageSize,
          jsonobj
        })
        .then((res) => {
          if (res.result) {
            this.StockCollect.list = res.data.result.records
            this.StockCollect.pageNo = res.data.result.current
            this.StockCollect.pageSize = res.data.result.size
            this.StockCollect.total = res.data.result.total
          }
          if (fn) fn()
        })
    },
    ShoppingCart(shop) {
      quest
        .ShoppingCart({
          params: `jsonobj=${encodeURI(
            JSON.stringify({
              shoppingCartList: shop
            })
          )}`
        })
        .then(res => {
          if (res.result) {
            this.$notify({
              customClass: 'shop-up',
              showClose: false,
              dangerouslyUseHTMLString: true,
              message: res.msg,
              duration: 1500,
              offset: 50
            })
            this.$parent.$parent.$refs.rightNav.comput.FSCQuanty++
          }
        })
    }
  }
}
</script>

<style lang="scss">
#child1 .body1 {
  height: calc(100vh - 162px);
  overflow-y: overlay;
}
</style>
